import { useMissionsTranslation } from '../../../../ui/hooks';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { Divider } from '@mui/material';
import React from 'react';
import { MissionDetails } from './MissionDetails';
export const MissionDetailsVolunteer = ({ missionId, missionName, missionType, missionStatus, missionPlaceholdersDetails, }) => {
    const { t } = useMissionsTranslation();
    const { upcomingAvailableShifts, myShifts } = missionPlaceholdersDetails;
    const isMissionClosed = missionStatus === 'closed';
    let placeHolders;
    if (!isMissionClosed) {
        placeHolders = [
            {
                icon: React.createElement(AssignmentOutlinedIcon, null),
                title: t('missions.availableShifts'),
                value: upcomingAvailableShifts,
            },
            {
                icon: React.createElement(AssignmentIndOutlinedIcon, null),
                title: t('missions.myShifts'),
                value: myShifts,
            },
        ];
    }
    else {
        placeHolders = [
            {
                icon: React.createElement(AssignmentIndOutlinedIcon, null),
                title: t('missions.myShifts'),
                value: myShifts,
            },
        ];
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MissionDetails, { missionId: missionId, missionName: missionName, missionType: missionType, missionStatus: missionStatus, placeHolders: placeHolders }),
        !isMissionClosed && React.createElement(Divider, { sx: { mx: 2 } })));
};
